
import styled from "styled-components";

const Component = styled.div`
    width: 100%;
    background: ${props => props.white ? "white" : props.theme.color.backgroundShade };
    padding: ${props => props.theme.spacing.l}rem 0;
`;

export default Component;